import { render, staticRenderFns } from "./PnlMonitor.vue?vue&type=template&id=a1bd75de&lang=pug"
import script from "./PnlMonitor.vue?vue&type=script&lang=js"
export * from "./PnlMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports